export default "__VITE_ASSET__BcGf6Mr9__"